angular.module('unica_wiki.wiki_services')

.factory('WikiCreateService', function ($http, getBaseApiURL) {

	var wikiCreateService = {};

	wikiCreateService.create = function (wikiData)
	{
		return $http({
			method: 'post',
			url: getBaseApiURL + '/wiki/create',
			data: wikiData
		}).then(function(result) {

			if ( result ) {
				return result.data.changelog;
			}

		});
	};

	return wikiCreateService;
});